export default {
    $_veeValidate: {        
        // the name getter
        name () {            
            return this.field.name ;
        },
        // the value getter
        value () {
            return this.value; // `this` is the component instance, `value` is the prop we added.
        },
    },
    
    data() {
        return {
            innerValue: 'initial'
        }
    },

    props: {
        field: {
            type: Object
        },
        
        value: {
            type: [String, Boolean]            
        },
        
        error: {
            type: String
        },
        
        inputClass:{
            type: String
        }
    },
    computed: {
        name(){
            return (this.field.translationKey) ? 
                this.i18n.get(this.field.translationKey) : 
                this.field.name;
        }
    },
    methods: {
        update(e) {            
            this.$emit('input', event.target.value);
        },

        showLoginForm() {
            this.$emit('changeView', {
                view: 'LoginComponent'
            });
        },

        showRegistrationForm() {
            this.$emit('changeView', {
                view: 'RegisterComponent'
            });
        },

        showForgotPasswordForm() {
            this.$emit('changeView', {
                view: 'ForgotPasswordComponent'
            })
        },
    }
}
